import React from 'react';
import { Spin } from 'antd';

export default ({ size = "large" }) => (
  <div style={{ width: 50, margin: 'auto'}}>
    <Spin spinning size={size} />
  </div>
)